import { SESSION_KEY, AZFN_GET_COMMUNITY_RESOURCES, AZFN_GET_COMMUNITY_SCHOLAR_RESOURCES, AZFN_GET_FUTURE_READY_RESOURCES, AZFN_GET_HR_MEDICAID_RESOURCES } from "../common/constants"
import axios from "axios"
import { getCached, setCached } from "@utilities"

export const getResources = async (type) => {
  let azureFunction = AZFN_GET_COMMUNITY_RESOURCES
  let sessionStorageKey = SESSION_KEY.COMMUNITY_RESOURCES
  switch (type) {
    case "community-scholar":
      azureFunction = AZFN_GET_COMMUNITY_SCHOLAR_RESOURCES
      sessionStorageKey = SESSION_KEY.COMMUNITY_SCHOLAR_RESOURCES
      break;
    case "future-ready":
      azureFunction = AZFN_GET_FUTURE_READY_RESOURCES
      sessionStorageKey = SESSION_KEY.FUTURE_READY_RESOURCES
      break;
    case "hr-medicaid":
      azureFunction = AZFN_GET_HR_MEDICAID_RESOURCES
      sessionStorageKey = SESSION_KEY.HR_MEDICAID_RESOURCES
      break;
    default:
      break;
  }
  let resourceData = getCached(sessionStorageKey)
  if (!resourceData) {
    const response = await axios.get(`${azureFunction}`)
    resourceData = response.data
    setCached(sessionStorageKey, resourceData)
  }
  return resourceData
}
